import { MarkupError } from "../../markup/errors.js";
import { parseMarkup, type XmlElement } from "../../markup/xml.js";
import { compileDefinition, defineArt } from "./drawing.js";

type Extra = (element: XmlElement) => void;

/** What else a library file may hold besides `<Define>` - `<Look>`, registered by the looks module. */
const extras = new Map<string, Extra>();

/** Teach `registerArtLibrary` another top-level element. */
export function registerLibraryElement(name: string, handler: Extra): void {
  extras.set(name, handler);
}

/** Read one library element - a `<Define>`, a `<Look>` - and register it. False when it is not one. */
export function registerLibraryChild(element: XmlElement): boolean {
  if (element.name === "Define") {
    defineArt(compileDefinition(element));
    return true;
  }
  const extra = extras.get(element.name);
  if (!extra) return false;
  extra(element);
  return true;
}

/**
 * Register everything in a library: a `<Library>` of `<Define>` and `<Look>` elements, or one of
 * them on its own. Re-registering a name replaces it, the way every registry here works.
 */
export function registerArtLibrary(xml: string): void {
  const root = parseMarkup(xml);
  const items = root.name === "Library" ? root.children : [root];
  for (const item of items) {
    if (!registerLibraryChild(item)) {
      throw new MarkupError(`a library holds <Define> and <Look>, not <${item.name}>`, item);
    }
  }
}
